module.exports = __webpack_public_path__ + "images/data-7a0ef849428b927b9d5c902770885464.png";